import { AxiosResponse } from "axios";

export const getAPIData = (promise: Promise<AxiosResponse>) => {
  return promise.then((res) => {
    if (!res || !res.data) {
      return Promise.reject("No data");
    }
    return res.data;
  });
};

export const getProductOptions = async (promise: Promise<any>) => {
  const products = await promise;
  return products.map((product: any) => ({
    label: product.title,
    value: product.id,
    icon: product.image?.src,
  }));
};
